// extracted by mini-css-extract-plugin
export default {"element":"footer_element__YM-Xi","noPad":"footer_noPad__Lfz1y","inner":"footer_inner__+4Vr5","copyright":"footer_copyright__izYg2","socialLinks":"footer_socialLinks__Askpk"};